import PieChart from 'components/PieChart';
import React from 'react';

import { DomainStatsData } from '../../types';

interface UniqueEngagementVsSiteChartProps {
  domainStats: DomainStatsData;
}

const UniqueEngagementVsSiteChart: React.FunctionComponent<
  UniqueEngagementVsSiteChartProps
> = (props) => {
  const { domainStats } = props;

  if (domainStats.loading) {
    return null;
  }

  return (
    <PieChart
      data={domainStats.data}
      getDataPoint={(entry) => ({
        name:
          entry.sourceType === 'app'
            ? `${entry.displayName} (App)`
            : entry.displayName,
        y: entry.spEngaged,
      })}
      seriesName="Unique Engagement"
    />
  );
};

export default UniqueEngagementVsSiteChart;
